import axios from 'axios'

export const AxiosPlugin = {
  install: (Vue, { baseURL }) => {
    Vue.prototype.$axios = axios
    axios.defaults.baseURL = baseURL
  }
}
